import {observer} from 'mobx-react-lite';
import React from 'react';
import {View, StyleSheet} from 'react-native';
import {View as AnimatableView} from 'react-native-animatable';
import Svg, {Path} from 'react-native-svg';
import {useRoot} from '../Root/hooks';
import {variance} from '../styling';

export default observer(function InAppLoader() {
  const {inAppLoaderState} = useRoot();
  if (!inAppLoaderState.isVisible) {
    return null;
  }
  return (
    <RootView>
      <AnimatableView
        animation="rotate"
        easing="linear"
        iterationCount="infinite"
        style={styles.content}>
        <View style={styles.circle}>
          <Svg width="26" height="26" viewBox="0 0 26 26" fill="none">
            <Path
              d="M12.9793 25.2199C6.25296 25.2199 0.782227 19.7472 0.782227 13.0208C0.782227 6.29451 6.25296 0.821777 12.9793 0.821777C19.7056 0.821777 25.1783 6.29451 25.1783 13.0208C25.1783 19.7472 19.7056 25.2199 12.9793 25.2199Z"
              fill="white"
            />
          </Svg>
        </View>
        <Svg width="76" height="78" viewBox="0 0 76 78" fill="none">
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M29.5514 8.73489C32.8983 13.0001 35.3269 17.796 36.7555 22.7756L36.7626 22.7753C37.1684 22.7551 37.5743 22.7349 38.0004 22.7349C41.9596 22.7349 45.6126 24.1635 48.4289 26.5308C50.429 22.6532 51.6535 18.5512 52.1228 14.4287C52.5106 10.796 52.327 7.14301 51.6126 3.73489C51.4699 3.04093 50.9597 2.48989 50.327 2.24499C46.3065 0.755236 42.7964 0.285889 38.0004 0.285889C34.2657 0.285889 30.6739 0.796093 27.2861 1.77564C25.7964 2.20426 25.3473 4.08177 26.429 5.18377C27.5514 6.30632 28.5922 7.48991 29.5514 8.73489ZM7.57162 31.1839C6.02058 31.388 4.46954 31.6941 2.93893 32.1022C1.42874 32.49 0.0409881 31.1431 0.408315 29.6329C2.3267 21.9186 6.57162 15.1226 12.3266 10.0206C12.8777 9.53078 13.6328 9.36759 14.3267 9.59206C17.6328 10.6736 20.8369 12.3471 23.7757 14.5104C27.1022 16.9389 30.041 20.0819 32.4083 23.7145C28.4287 25.1839 25.1634 28.1634 23.3471 31.9593C18.3471 30.7145 12.939 30.4287 7.57162 31.1839ZM39.2659 55.2041C40.6944 60.1837 43.123 65 46.47 69.2654C47.4291 70.4898 48.4495 71.6735 49.5719 72.8163C50.6536 73.9183 50.2046 75.7755 48.7148 76.2042C45.3271 77.1837 41.7353 77.7143 38.021 77.7143C33.2251 77.7143 29.6944 77.2449 25.674 75.7551C25.0414 75.5102 24.5312 74.9388 24.3883 74.2654C23.674 70.8368 23.4904 67.2041 23.8985 63.5715C24.3679 59.449 25.5923 55.347 27.5924 51.4694C30.4088 53.8572 34.0618 55.2654 38.0005 55.2654C38.4292 55.2654 38.8577 55.245 39.2659 55.2041ZM68.4495 46.8167C69.9801 46.5923 71.5311 46.2861 73.0618 45.8983C74.5719 45.5106 75.9598 46.8576 75.5924 48.3677C73.674 56.082 69.4292 62.8779 63.6536 67.98C63.1026 68.4493 62.3475 68.6126 61.6537 68.3882C58.3475 67.286 55.1434 65.6534 52.2251 63.4902C48.919 61.0412 45.9598 57.9188 43.6128 54.2657C47.5924 52.7963 50.8374 49.8167 52.6536 46.0412C57.674 47.286 63.0823 47.5718 68.4495 46.8167ZM54.2654 38.9998C54.2654 39.9591 54.1837 40.8978 54.0205 41.7957C58.347 41.5917 62.5307 40.5713 66.347 38.9387C69.6735 37.4692 72.7143 35.5101 75.3062 33.1836C75.8368 32.7142 76.0817 31.959 75.9388 31.2652C74.3674 23.4284 70.4286 16.4693 64.898 11.1428C63.7755 10.0611 61.9184 10.5917 61.5103 12.0815C61.0816 13.6121 60.5714 15.102 60.0001 16.5509C57.9797 21.5713 55.0205 26.1019 51.4082 29.8162C53.2041 32.4489 54.2654 35.5917 54.2654 38.9998ZM21.98 36.2045C21.8167 37.1024 21.7351 38.0413 21.7351 39.0004C21.7351 42.4086 22.7962 45.5514 24.5921 48.1636C21.0003 51.8984 18.0412 56.429 16.0207 61.4494C15.4289 62.8984 14.9391 64.3677 14.5105 65.878C14.1024 67.3678 12.2452 67.9188 11.1228 66.8371C5.59215 61.5107 1.63295 54.5514 0.0616221 46.7351C-0.0812351 46.0208 0.163643 45.2861 0.694275 44.7963C3.28603 42.4902 6.32683 40.531 9.67379 39.0617C13.4697 37.429 17.6534 36.4289 21.98 36.2045Z"
            fill="white"
          />
        </Svg>
      </AnimatableView>
    </RootView>
  );
});

const RootView = variance(View)((theme) => ({
  root: {
    flex: 1,
    backgroundColor: theme.chroma(theme.palette.foreground).alpha(0.3).hex(),
    justifyContent: 'center',
    alignItems: 'center',
  },
}));

const styles = StyleSheet.create({
  content: {
    width: 80,
    height: 80,
    justifyContent: 'center',
    alignItems: 'center',
  },
  circle: {
    position: 'absolute',
  },
});
